export default "__VITE_ASSET__0fc1d16c__"